import React from "react";
import { Sparkles } from "lucide-react";

export default function MatchScore({ score, size = "md" }) {
  const pct = Math.max(0, Math.min(100, Math.round(score || 0)));
  const dim = size === "lg" ? 96 : size === "sm" ? 56 : 72;
  const label = size === "lg" ? "compatibilidad" : "match";

  return (
    <div className="inline-flex items-center gap-3">
      <div
        className="match-ring"
        style={{ ["--pct"]: `${pct}%`, width: dim, height: dim }}
        aria-label={`${pct}% de compatibilidad`}
      >
        <div className="flex items-center justify-center rounded-full bg-white text-petroleum h-full w-full">
          <div className="text-center">
            <div className="font-display text-xl leading-none">{pct}%</div>
            <div className="text-[8px] uppercase tracking-widest text-slate-500 mt-0.5 flex items-center gap-1 justify-center">
              <Sparkles size={8} className="text-gold" /> {label}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
